/* eslint-disable @typescript-eslint/naming-convention */

import createSvgIcon from '../Utils/CreateSvgIcon';

export const MOT = createSvgIcon(
  <path
    clipRule="evenodd"
    d="m8.108 3 .827 1.435 3.234 5.61 3.563-5.644L16.617 3l.827 1.435 3.885 6.74.864 1.498h-8.552l3.248 5.636.865 1.5H6.07l.968-1.534 3.537-5.601H2l.968-1.534L7.223 4.4 8.108 3Zm-2.48 7.674h4.595L8.03 6.87l-2.402 3.804Zm8.51 0h4.594L16.539 6.87l-2.402 3.804Zm.154 7.135H9.698l2.401-3.804 2.193 3.804Z"
    fillRule="evenodd"
  />,
  'MOT',
);
